<template>
  <div>
    <nav class="checkout-navbar navbar navbar-expand-md navbar-dark bg-white fixed-top pt-4">
        <div class="d-none d-lg-flex container align-items-end">
            <a class="navbar-brand" href="/">
                <img src="/img/callshop.png" alt="威昌國際">
            </a>
            <div class="d-flex">
                <h2 class="text-primary">
                    01 <small>{{ $t('lang.R3004') }}</small>
                </h2>
                <hr class="d-inline-block px-5 mx-4 border-primary">
                <h2 :class="[step > 1 ? 'text-primary' : 'text-black-30' ]">
                    02 <small>{{ $t('lang.R3002') }}</small>
                </h2>
                <hr class="d-inline-block px-5 mx-4 border-primary">
                <h2 :class="[step > 2 ? 'text-primary' : 'text-black-30' ]">
                    03 <small>{{ $t('lang.R3042') }}</small>
                </h2>
            </div>
        </div>
        <div class="d-flex d-lg-none flex-column w-100">
            <h4 class="text-primary w-100 text-center checkout-navbar-title">
              <a href="#" class="btn btn-link back-button" @click.prevent="step--" v-if="step > 1">
                <i data-feather="chevron-left"></i>
              </a>
              {{ step == 1 ? $t('lang.R3004') : $t('lang.R3002') }}
            </h4>
            <div class="checkout-navbar-stepper d-flex mx-auto align-items-center">
                <span class="text-primary">01</span>
                <hr class="d-inline-block px-4 mx-2 my-0 text-primary">
                <span :class="[step > 1 ? 'text-primary' : 'text-black-30' ]">02</span>
                <hr class="d-inline-block px-4 mx-2 my-0 text-black-30">
                <span :class="[step > 2 ? 'text-primary' : 'text-black-30' ]">03</span>
            </div>
        </div>
    </nav>
    <div class="container">
      <div class="row" v-show="step == 0">
        <div class="col-lg-8 col-12 m-auto">
          <h3 class="text-primary text-center mb-4 d-none d-lg-block">{{ $t('lang.會員合約') }}</h3>
          <slot name="policy"></slot>
          <div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="agree" v-model="agree">
              <label class="form-check-label" for="agree">
                {{ $t('lang.下載列印合約，畫大小□ 請蓋公司章及小章、騎縫章') }}
              </label>
            </div>
          </div>
          <div class="form-row my-4 justify-content-center">
            <a :href="contract" target="_blank" class="btn px-4 mr-4 btn-primary">{{ $t('lang.R3038') }}</a>
            <button class="btn px-4 btn-primary" :disabled="!agree" @click="step = 1">{{ $t('lang.R3040') }}</button>
          </div>
        </div>
      </div>
      <div class="row" v-show="step == 1">
        <div class="col-xl-6 col-lg-9 col-12 m-auto">
          <h3 class="text-primary text-center mb-4 d-none d-lg-block">{{ $t('lang.R3004') }}</h3>
          <ValidationObserver ref="form" class="form" v-slot="{ invalid }">
            <ValidationProvider
              vid="account"
              :name="$t('lang.R3014')"
              rules="required|digits:8"
              tag="div"
              class="form-row mb-4"
              v-slot="{ errors, failed }"
            >
              <label>{{ $t('lang.R3014') }}*</label>
              <input type="text" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.account" maxlength="8">
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </ValidationProvider>

            <ValidationProvider
              vid="password"
              :name="$t('lang.R2010')"
              rules="required"
              tag="div"
              class="form-row mb-4"
              v-slot="{ errors, failed }"
            >
              <label>{{ $t('lang.R2010') }}</label>
              <input type="password" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.password">
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </ValidationProvider>

            <ValidationProvider
              vid="password_confirmation"
              :name="$t('lang.R2011')"
              rules="required|confirmed:password"
              tag="div"
              class="form-row mb-4"
              v-slot="{ errors, failed }"
            >
              <label>{{ $t('lang.R2011') }}</label>
              <input type="password" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.password_confirmation">
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </ValidationProvider>

            <ValidationProvider
              vid="name"
              :name="$t('lang.D5021')"
              rules="required"
              tag="div"
              class="form-row mb-4"
              v-slot="{ errors, failed }"
            >
              <label>{{ $t('lang.D5021') }}</label>
              <input type="text" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.name">
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </ValidationProvider>

            <ValidationProvider
              vid="contact_person"
              :name="$t('lang.D5026')"
              rules="required"
              tag="div"
              class="form-row mb-4"
              v-slot="{ errors, failed }"
            >
              <label>{{ $t('lang.D5026') }}</label>
              <input type="text" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.contact_person">
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </ValidationProvider>

            <ValidationProvider
              vid="owner"
              :name="$t('lang.D5025')"
              rules="required"
              tag="div"
              class="form-row mb-4"
              v-slot="{ errors, failed }"
            >
              <label>{{ $t('lang.D5025') }}</label>
              <input type="text" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.owner">
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </ValidationProvider>

            <ValidationProvider
              vid="email"
              :name="$t('lang.R3019')"
              rules="required|email"
              tag="div"
              class="form-row mb-4"
              v-slot="{ errors, failed }"
            >
              <label>{{ $t('lang.R3019') }}</label>
              <input type="text" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.email">
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </ValidationProvider>

            <div class="form-row mb-4 no-gutters">
              <div class="col-12 p-0">
                <label>{{ $t('lang.R3017') }}*</label>
              </div>

              <ValidationProvider
                :name="$t('lang.縣市')"
                rules="required"
                tag="div"
                class="form-group col-md-3 pl-0"
                v-slot="{ errors, failed }"
              >
                <label for="input-zipcode">{{ $t('lang.縣市') }}</label>
                <select id="input-zipcode" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.address.city">
                  <option
                    v-for="(city, index) in cities"
                    :key="index"
                    :value="city"
                  >
                    {{ city }}
                  </option>
                </select>
              </ValidationProvider>

              <ValidationProvider
                :name="$t('lang.地區')"
                rules="required"
                tag="div"
                class="form-group col-md-3 pl-0"
                v-slot="{ errors, failed }"
              >
                <label for="input-zipcode">{{ $t('lang.地區') }}</label>
                <select id="input-zipcode" :class="['form-control', failed ? 'is-invalid' : null]" v-model="address">
                  <option
                    v-for="(zipcode, index) in zipcodes"
                    :key="index"
                    :value="`${zipcode.zip}|${zipcode.city}|${zipcode.name}`"
                  >
                    {{ zipcode.name }}
                  </option>
                </select>
              </ValidationProvider>

              <ValidationProvider
                :name="$t('lang.R3011')"
                rules="required"
                tag="div"
                class="form-group col pr-0"
                v-slot="{ errors, failed }"
              >
                <label>{{ $t('lang.R3011') }}</label>
                <input type="text" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.address.street">
                <div class="invalid-feedback">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="form-row mb-4">
              <ValidationProvider
                vid="mobile"
                :name="$t('lang.行動電話')"
                rules="required|digits:10"
                tag="div"
                class="col pl-0"
                v-slot="{ errors, failed }"
              >
                <label>{{ $t('lang.行動電話') }}</label>
                <input type="text" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.mobile" v-mask="'##########'">
                <div class="invalid-feedback">{{ errors[0] }}</div>
              </ValidationProvider>
              <div class="col pr-0">
                <label>LINE</label>
                <input type="text" class="form-control" v-model="form.line">
              </div>
            </div>

            <div class="form-row mb-4">
              <div class="col-12 p-0">
                <label>{{ $t('lang.R3018') }}*</label>
              </div>
              <div class="col col-auto">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="same-phone" v-model="isSamePhone">
                  <label class="form-check-label" for="same-phone">
                    {{ $t('lang.同上') }}
                  </label>
                </div>
              </div>
              <div class="col">
                <input type="text" class="form-control" :disabled="isSamePhone" v-model="form.phone">
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="w-100">{{ $t('lang.R3013') }}*</label>

               <ValidationProvider
                :name="$t('lang.R3013')"
                v-slot="{ errors, failed }"
                tag="div"
                class="input-group col-12 col-sm-6 pl-0 mb-2"
              >
                <input type="text" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.opening_hours.start" v-mask="'##:##'" placeholder="09:00">
                <div class="input-group-prepend">
                  <span class="input-group-text">~</span>
                </div>
                <input type="text" :class="['form-control', failed ? 'is-invalid' : null]" v-model="form.opening_hours.end" v-mask="'##:##'" placeholder="18:00">
              </ValidationProvider>

              <div class="w-100">
                <input type="text" class="form-control" v-model="form.opening_hours.dayOff" :placeholder="$t('lang.休假日及其他')">
              </div>
            </div>

            <div class="form-row" v-for="(bank, index) in form.bank" :key="index">
              <div class="col-12 pl-0">
                {{ index+1 }}. {{ $t('lang.往來銀行') }}
              </div>
              <div class="form-group col-6 col-md-3 pl-0">
                <label>{{ $t('lang.銀行名稱') }}</label>
                <input type="text" class="form-control" v-model="bank.name">
              </div>
              <div class="form-group col-6 col-md-4">
                <label>{{ $t('lang.戶名') }}</label>
                <input type="text" class="form-control" v-model="bank.account_name">
              </div>
              <div class="form-group col-12 col-md-5 py-0">
                <label>{{ $t('lang.銀行帳號') }}</label>
                <input type="text" class="form-control" v-model="bank.account_number">
              </div>
            </div>
            <div class="form-row mb-4 justify-content-center">
              <button
                class="btn px-4 btn-primary"
                @click="goNext"
              >
                {{ $t('lang.R3040') }}
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
      <div class="row" v-show="step == 2">
        <div class="col-lg-6 col-12 m-auto">
          <h3 class="text-primary text-center mb-4">{{ $t('lang.R3005') }}</h3>
          <label>
            {{ $t('lang.最新設立登記函或變更事項登記函') }}*
            <small class="text-muted">{{ $t('lang.此檔為審核用, 紙本以寄回實際張數為準') }}</small>
          </label>
          <div class="row mb-4">
            <div class="col-6">
              <image-uploader
                name="register_letter_1"
                :height="300"
                :placeholder="$t('lang.R3023')"
                @file="onFile"
              />
            </div>
            <div class="col-6">
              <image-uploader
                name="register_letter_2"
                :height="300"
                :placeholder="$t('lang.R3023')"
                @file="onFile"
              />
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-6">
              <image-uploader
                name="register_letter_3"
                :height="300"
                :placeholder="$t('lang.R3023')"
                @file="onFile"
              />
            </div>
            <div class="col-6">
              <image-uploader
                name="register_letter_4"
                :height="300"
                :placeholder="$t('lang.R3023')"
                @file="onFile"
              />
            </div>
          </div>
          <label>
            {{ $t('lang.負責人第一證件') }}*
            <small class="text-muted">{{ $t('lang.負責人需滿20歲') }}</small>
          </label>
          <div class="row mb-4">
            <div class="col-6">
              <image-uploader
                name="id_front"
                :height="300"
                :placeholder="$t('lang.R3023')"
                @file="onFile"
              />
            </div>
            <div class="col-6">
              <image-uploader
                name="id_back"
                :height="300"
                :placeholder="$t('lang.R3023')"
                @file="onFile"
              />
            </div>
          </div>
          <label>{{ $t('lang.公司門牌、大門、內部照片') }}*</label>
          <div class="row mb-4">
            <div class="col-6">
              <image-uploader
                name="company_1"
                :height="300"
                :placeholder="$t('lang.R3023')"
                @file="onFile"
              />
            </div>
            <div class="col-6 mb-4">
              <image-uploader
                name="company_2"
                :height="300"
                :placeholder="$t('lang.R3023')"
                @file="onFile"
              />
            </div>
            <div class="col-12">
              <image-uploader
                name="company_3"
                :height="300"
                :placeholder="$t('lang.R3023')"
                @file="onFile"
              />
            </div>
          </div>
          <label>{{ $t('lang.R3024') }}</label>
          <div class="row">
            <div class="col-12 mb-4" v-for="index in 4" :key="`bankbook_cover_${index}`">
              <image-uploader
                :name="`bankbook_cover_${index}`"
                :height="300"
                :placeholder="$t('lang.D6010')"
                @file="onFile"
              />
            </div>
          </div>
          <div v-if="isLoading" class="alert alert-link text-center">
            <div class="spinner-border text-primary mb-3" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <h5>{{ $t('lang.送件中，請耐心等候。') }}</h5>
          </div>
          <p v-else class="text-center">
            <button
              href="#"
              class="btn btn-outline-primary px-4 mr-2"
              :disabled="isLoading"
              @click.prevent="step = 1"
            >
              {{ $t('lang.R3041') }}
            </button>
            <button
              class="btn btn-primary px-4 ml-2"
              @click="submit"
              :disabled="isMissingImage || isLoading"
            >
              {{ $t('lang.送件') }}
            </button>
          </p>
        </div>
      </div>
      <div class="row" v-show="step == 3">
        <div class="col-lg-6 col-12 m-auto text-center">
          <h3 class="text-primary mb-4">{{ $t('lang.R3034') }}</h3>
          <h5 class="bg-white p-5">
            {{ $t('lang.已申請送件！我們將在最短時間內處理您的申請！') }}
          </h5>
          <p class="mt-4">
            <a href="/" class="btn btn-primary px-4 ml-2">{{ $t('lang.回首頁') }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import twZipCode from '../../../libs/zipcodes';
import ImageUploader from '../components/ImageUploader';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import API from '../../api';

export default {
  props: {
    contract: String,
  },

  components: {
    ImageUploader,
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      twZipCode,
      step: 0,
      agree: false,
      isLoading: false,
      isSamePhone: false,
      form: {
        status: 'applied',
        tax_type: 'B2B',
        account: null,
        password: null,
        password_confirmation: null,
        name: null,
        owner: null,
        contact_person: null,
        address: {
          post_code: null,
          city: null,
          district: null,
          street: null,
        },
        locale: 'zh-tw',
        mobile: null,
        phone: null,
        line: null,
        opening_hours: {
          start: null,
          end: null,
          dayOff: null,
        },
        bank: [1,2,3,4].map(() => {
          return {
            name: null,
            account_name: null,
            account_number: null,
          }
        }),
        images: {
          register_letter_1: null,
          register_letter_2: null,
          register_letter_3: null,
          register_letter_4: null,
          id_front: null,
          id_back: null,
          bankbook_cover_1: null,
          bankbook_cover_2: null,
          bankbook_cover_3: null,
          bankbook_cover_4: null,
          company_1: null,
          company_2: null,
          company_3: null,
        },
      }
    }
  },

  computed: {
    cities() {
      return this.twZipCode.map(city => city.name);
    },

    zipcodes() {
      if (!this.form.address.city) {
        return [];
      }

      return _.chain(this.twZipCode)
              .find(city => city.name == this.form.address.city)
              .get('districts')
              .map(item => {
                item.city = this.form.address.city;
                return item;
              })
              .value();
    },

    address: {
      get() {
        return this.form.address.post_code ? [
          this.form.address.post_code,
          this.form.address.city,
          this.form.address.district,
        ].join('|') : null;
      },

      set(value) {
        let [ post_code, city, district ] = value.split('|');
        this.form.address = {...this.form.address, ...{ post_code, city, district }};
      },
    },

    isMissingImage() {
      return _.chain(this.form.images).pick([
        'register_letter_1',
        'id_front',
        'id_back',
        'company_1',
        'company_2',
        'company_3',
        'bankbook_cover_1',
      ])
      .values()
      .some(image => image == null)
      .value();
    },
  },

  watch: {
    isSamePhone() {
      if (this.isSamePhone) {
        this.form.phone = this.form.mobile;
      }
    },

    'form.mobile'() {
      if (this.isSamePhone) {
        this.form.phone = this.form.mobile;
      }
    },

    step() {
      this.$nextTick(() => {
        window.feather.replace();
        this.scrollToTop();
      });
    },
  },

  methods: {
    scrollToTop() {
      (document.documentElement || document.body).scrollTop = 0;
    },

    onFile(file, name) {
      this.form.images[name] = file;
    },

    async goNext() {
      let result = await this.$refs.form.validate();
      if (result) {
        this.step = 2;
      } else {
        this.scrollToTop();
      }
    },

    async submit() {
      this.isLoading = true;
      try {
        await API.register.create(this.form);
        this.step = 3;
      } catch (error) {
        if (_.get(error, 'response.status') == 422) {
          this.$refs.form.setErrors(error.response.data.errors);
          this.step = 1;
          alert(this.$t('lang.資料有錯誤，請確認'));
        } else {
          console.error(error);
          alert(this.$t('lang.送件失敗！'));
        }
      }
      this.isLoading = false;
    },
  },
}
</script>
